// Drill-down step model for the Find view: Source -> Subject -> Grade -> Sets -> Set tree.
// Subject and Grade steps auto-skip when there is nothing to decide (<= 1 option), so Back
// navigation must hop over the skipped steps. These helpers keep that logic pure and testable.

export type FunnelStep = 'source' | 'subject' | 'grade' | 'sets' | 'setTree';

export interface FunnelSkips {
  subject: boolean;
  grade: boolean;
}

const ORDER: FunnelStep[] = ['source', 'subject', 'grade', 'sets', 'setTree'];

/** A facet step (subject / grade) is auto-skipped when it has 0 or 1 option to choose. */
export function shouldSkipFacet(optionCount: number): boolean {
  return optionCount <= 1;
}

/** The previous visible step, hopping over any auto-skipped subject/grade steps. */
export function previousStep(step: FunnelStep, skips: FunnelSkips): FunnelStep {
  let index = ORDER.indexOf(step) - 1;
  while (index > 0) {
    const candidate = ORDER[index];
    if (candidate === 'subject' && skips.subject) {
      index -= 1;
      continue;
    }
    if (candidate === 'grade' && skips.grade) {
      index -= 1;
      continue;
    }
    break;
  }
  return ORDER[Math.max(0, index)];
}
